/* Collection hub (2026-10): row states for the category rows.
   For each row that can scroll sideways, sets classes on .cf-hub__row:
   - is-scrollable: the row has more products than fit (shows the fade,
     progress bar and the phone "Swipe for more" hint)
   - is-start / is-end: at the start / end (hides the back / forward arrow and the fade)
   and moves the red progress bar. Arrows themselves are Dawn's
   slider-component (assets/global.js). Loaded by snippets/collection-hub.liquid. */
(function () {
  function update(row, list, bar) {
    var max = list.scrollWidth - list.clientWidth;
    var scrollable = max > 2;
    row.classList.toggle('is-scrollable', scrollable);
    row.classList.toggle('is-start', list.scrollLeft <= 2);
    row.classList.toggle('is-end', !scrollable || list.scrollLeft >= max - 2);
    if (bar && scrollable) {
      bar.style.width = (list.clientWidth / list.scrollWidth) * 100 + '%';
      bar.style.left = (list.scrollLeft / list.scrollWidth) * 100 + '%';
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.cf-hub__row').forEach(function (row) {
      if (row.dataset.cfHubReady) return;
      var list = row.querySelector('.slider');
      if (!list) return;
      row.dataset.cfHubReady = 'true';
      var bar = row.querySelector('.cf-hub__progress span');
      var run = function () {
        update(row, list, bar);
      };
      list.addEventListener('scroll', run, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(run).observe(list);
      window.addEventListener('resize', run);
      window.addEventListener('load', run);
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: re-run when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
